import { Tooltip } from "@material-ui/core";
import React, { useEffect } from 'react';
import BlockUi from "react-block-ui";
import { Badge, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

function SvgCreditCard(props) {
  const payment_method = useSelector(
    state => state.app.payment_methods_relation
  ).find(relation => relation.id === props.brand.toLowerCase());
  return (
    <>
      {payment_method && (
        <img alt="" src={payment_method.svg} style={{ height: "23px" }} />
      )}
    </>
  );
}

const SUBSCRIPTION_PAYMENT_BOLETO = "boleto";
const SUBSCRIPTION_PAYMENT_CREDIT_CARD = "credit_card";
const ACTIVE_PAID_STATUSES = ["active", "paid"];

export default function CartoesCredito(props) {
  const clientSubscription = useSelector(state => state.app.client_subscription);
  const isActive = clientSubscription?.isActive;
  const credit_cards = useSelector(state => state.app.cards);
  const is_loading_cards = useSelector(state => state.app.is_loading_cards);

  const subscriptionPaymentMethod = clientSubscription?.info?.payment_method;
  const subscriptionStatus = clientSubscription?.info?.status;
  const isSubscriptionBoleto = subscriptionPaymentMethod === SUBSCRIPTION_PAYMENT_BOLETO;
  const isSubscriptionActivePaid =
    subscriptionPaymentMethod === SUBSCRIPTION_PAYMENT_CREDIT_CARD &&
    ACTIVE_PAID_STATUSES.includes(subscriptionStatus);

  const canRemoveCard = row => {
    if (isSubscriptionBoleto) return true;
    if (isSubscriptionActivePaid) return !row.in_use;
    return true;
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'LOAD_CARDS',
      payload: {
        client_id: props.cliente_id,
        useV2: !!clientSubscription.external_id,
      },
    });
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, props.cliente_id]);

  const onCardDelete = id => {
    dispatch({
      type: 'DELETE_CARD',
      payload: {
        id,
        client_id: props.cliente_id,
        useV2: !!clientSubscription.external_id, 
      },
    });
  };

  const removeCardAction = card => () => {
    const answer = window.confirm(
      `Tem certeza que deseja excluir o cartão com final:  ${card.last_digits}? Esta ação não poderá ser desfeita`
    );
    if (!answer) {
      return;
    }
    onCardDelete(card.id);
  };

  const setPrimaryAction = card => () => {
    if (card?.in_use) {
      toast.info("Este cartão já está em uso como principal");
      return;
    }

    const answer = window.confirm(
      `Definir o cartão com final ${card.last_digits} como principal?`
    );
    if (!answer) return;

    dispatch({
      type: "SET_PRIMARY_CARD",
      payload: {
        cardId: card.id,
        client_id: props.cliente_id,
        useV2: !!clientSubscription.external_id,
        callback: () => {}
      }
    });
  };

  const datatable_credit_cards_columns = [
    {
      name: "Número do cartão",
      selector: row => `●●●● ●●●● ●●●● ${row.last_digits}`
    },
    {
      name: "Bandeira",
      selector: row => <SvgCreditCard brand={row.brand} className="mb-5" />
    },
    {
      name: "Validade",
      selector: row => row.expiration_date
    },
    {
      name: "Detalhes",
      selector: row => <>{row.in_use && <Badge variant="info">Em uso</Badge>}</>
    },
    {
      name: "Ações",
      selector: row => {
        if (props.formik.values.deleted_at) return null;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap"
            }}
          >
            <Tooltip
              disableHoverListener={isActive}
              disableFocusListener={isActive}
              disableTouchListener={isActive}
              title="Você só pode definir um cartão como principal se o cliente possuir um plano ativo."
            >
              <span tabIndex={isActive ? undefined : 0}>
                <Button
                  variant="success"
                  size="sm"
                  disabled={row.in_use || !isActive}
                  title={
                    row.in_use
                      ? "Este cartão já é o principal"
                      : "Definir como principal"
                  }
                  onClick={setPrimaryAction(row)}
                  style={{
                    borderRadius: 999,
                    padding: "6px 12px",
                    fontWeight: 700
                  }}
                  aria-label="Definir como principal"
                >
                  Usar
                </Button>
              </span>
            </Tooltip>

            <Button
              variant="danger"
              size="sm"
              disabled={!canRemoveCard(row)}
              title={
                !canRemoveCard(row)
                  ? "Este cartão está em uso e não pode ser apagado (assinatura ativa com cartão)."
                  : "Excluir cartão"
              }
              onClick={removeCardAction(row)}
              style={{
                borderRadius: 999,
                padding: "6px 12px",
                fontWeight: 700
              }}
              aria-label="Excluir cartão"
            >
              Excluir
            </Button>
          </div>
        );
      }
    }
  ];

  const removalRuleBadge =
    isSubscriptionBoleto
      ? "Assinatura em boleto: qualquer cartão pode ser removido."
      : isSubscriptionActivePaid
        ? "Assinatura ativa em cartão: o cartão em uso não pode ser removido."
        : "Assinatura em cartão (não ativa/paga): qualquer cartão pode ser removido.";

  return (
    <BlockUi tag="div" blocking={is_loading_cards}>
      {credit_cards?.length ? (
        <>
          {isSubscriptionActivePaid && (
            <p>
              Para manter a assinatura ativa é necessário ter pelo menos um
              cartão cadastrado. A assinatura deve ser cancelada antes de
              remover um cartão único.
            </p>
          )}
          {subscriptionPaymentMethod && (
            <Badge variant="secondary" className="mb-2 d-inline-block">
              {removalRuleBadge}
            </Badge>
          )}
        </>
      ) : null}
      {!is_loading_cards ? (
        <DataTable
          highlightOnHover
          noDataComponent="Usuário sem cartões cadastrados."
          columns={datatable_credit_cards_columns}
          data={credit_cards}
        />
      ) : null}
    </BlockUi>
  );
}
